<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import { reviewsFormModalToken } from "@apps/reviews/tokens";
    import CanLeaveReviewService from "@apps/reviews/widgets/review_form_modal_widget/services/CanLeaveReviewService";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { CommonModule } from "@modules/common_module/CommonModule";
    import { container } from "tsyringe";

    import { modalManagerContextKey } from "@components/Modal/ModalManager/constants";
    import Spinner from "@components/Spinner/Spinner.svelte";
    import { stepperControllerContextToken } from "@components/Stepper/context_tokens";

    import {
        LEAVE_REVIEW_SOURCE,
        REVIEWS_FORM_STEPS_NAMES,
    } from "../../../constants";
    import ReviewsWizardManager from "../../../managers/ReviewsWizardManager";
    import LeaveReviewQuery from "../../../queries/LeaveReviewQuery";
    import PurchasedProductsQuery from "../../../queries/PurchasedProductsQuery";
    import RewardForReviewQuery from "../../../queries/RewardForReviewQuery";
    import LeaveReviewEarningRuleService from "../../../services/LeaveReviewEarningRuleService";
    import RewardForReviewService from "../../../services/RewardForReviewService";
    import ResultStepReward from "./ResultStepReward.svelte";
    import ResultStepSuccess from "./ResultStepSuccess.svelte";

    export let leaveReviewQuery: LeaveReviewQuery;
    export let rewardForReviewQuery: RewardForReviewQuery;
    export let leaveReviewEarningRuleService: LeaveReviewEarningRuleService;
    export let rewardForReviewService: RewardForReviewService;
    export let reviewsWizardManager: ReviewsWizardManager;
    export let isAuthenticated: boolean;
    export let canLeaveReviewService: CanLeaveReviewService;
    export let purchasedProductsQuery: PurchasedProductsQuery;
    export let source: LEAVE_REVIEW_SOURCE;
    export let showPurchasedProducts: boolean;
    export let isTestReview: boolean;

    const stepperController = getTypedContext(stepperControllerContextToken);
    const modalManager = getTypedContext(modalManagerContextKey);

    const locationController =
        container.resolve(CommonModule).exports.locationController;
    const urlsBuilder = container.resolve(CommonModule).exports.urlsBuilder;

    const leaveReviewStatus$ = leaveReviewQuery.leaveReviewStatus$;
    const leaveReviewError$ = leaveReviewQuery.leaveReviewError$;
    const review$ = leaveReviewQuery.review$;

    const rewardForReview$ = rewardForReviewQuery.reward$;
    const rewardForReviewStatus$ = rewardForReviewQuery.status$;
    const purchasedProducts$ = purchasedProductsQuery.all$;

    const handleClose = () => {
        if (source === LEAVE_REVIEW_SOURCE.LEAVE_REVIEW_PAGE_WIDGET) {
            locationController.goTo(urlsBuilder.createMainPageUrl());
        } else {
            modalManager.closeModal(reviewsFormModalToken);
            reviewsWizardManager.resetForms();
            stepperController.resetAnimation();
            stepperController.resetCurrentStep();
            canLeaveReviewService.resetCanLeaveReviewStore();
        }
    };

    const handleContinue = () => {
        reviewsWizardManager.resetForms();
        leaveReviewEarningRuleService.resetStore();
        rewardForReviewService.resetStore();
        stepperController.goToStep(REVIEWS_FORM_STEPS_NAMES.RATING);
    };

    const setNavButtons = () => {
        if (showPurchasedProducts && $purchasedProducts$.length > 0) {
            reviewsWizardManager.setNextButton({
                type: "continue",
                isActive: true,
                onClick: handleContinue,
            });
        } else {
            reviewsWizardManager.setNextButton({
                type: "close",
                isActive: true,
                onClick: handleClose,
            });
        }

        reviewsWizardManager.setPrevButton(undefined);
    };

    $: {
        showPurchasedProducts;
        $purchasedProducts$;
        setNavButtons();
    }
</script>

<div class="gw-rv-form-result">
    {#if $rewardForReviewStatus$ === STATUS.LOADING}
        <div class="gw-rv-form-result__spinner-wrapper">
            <Spinner />
        </div>
    {:else if $rewardForReviewStatus$ === STATUS.READY && $rewardForReview$}
        <ResultStepReward
            on:closeReviewsFormModal={() =>
                modalManager.closeModal(reviewsFormModalToken)}
            reward={$rewardForReview$}
            {source}
        />
    {:else}
        <ResultStepSuccess
            leaveReviewStatus={$leaveReviewStatus$}
            leaveReviewError={$leaveReviewError$}
            isPublished={!!$review$?.isPublished}
            {isAuthenticated}
            {isTestReview}
        />
    {/if}
</div>

<style lang="postcss">
</style>
